import { Select as SelectBase } from "../base/Select";
import { connect, mapReadPretty, mapProps } from "@formily/react";
import { isField } from "@formily/core";

export const Select = connect(
  SelectBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      selectedKey: field.value,
      onSelectionChange: (value) => {
        void field.onInput(value);
      },
      isDisabled: field.disabled,
      isInvalid: field.errors.length > 0,
      items: field.dataSource,
    };
  }),
  mapReadPretty((props) => {
    return `${props.value}`;
  }),
);
